import { useMemo } from "react";
import AtendimentosModulo from "../../../../Components/Menu/Notificacoes/AtendimentosModulo";
import { useUserInfor } from "../../../../Context/User";
import { ListarAtividadesNotificacaoUsuario } from "../../../../Controllers/Geral/Notificacao/NotificacaoControllers";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";

export default function AtendimentoDoUsuarioDashboard() {
    const { MODULOS } = useUserInfor().UserInfor;
    const { value: lstAtividadesAtendimento } = useAsyncEffect(async () => {
        return ListarAtividadesNotificacaoUsuario().then((res) => {
            return res.filter((aa) =>
                MODULOS.some((m) => m.ID_MODULO === aa.ID_TIPO_CASO)
            );
        });
    }, [MODULOS]);

    const atendimentoSum = useMemo(
        () =>
            lstAtividadesAtendimento?.reduce((sum, aa) => {
                return sum + aa.NR_ATENDIMENTOS_ABERTOS;
            }, 0),
        [lstAtividadesAtendimento]
    );

    return (
        <div className="card card-custom h-100">
            <div className="card-header align-items-center justify-content-center">
                <div className="text-center flex-grow-1">
                    <div className="text-dark-75 font-weight-bold font-size-h5">
                        Meus Atendimentos - {atendimentoSum}
                    </div>
                </div>
            </div>
            <div className="card-body">
                <AtendimentosModulo
                    lstAtividadesAtendimento={lstAtividadesAtendimento}
                />
            </div>
        </div>
    );
}
